import { useState } from 'react';
import villaLogo from '../assets/Navbar/CINNAMON MANTRA (1).png';

const CONSENT_STORAGE_KEY = 'cinnamon-mantra-cookie-consent';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(
    () => window.localStorage.getItem(CONSENT_STORAGE_KEY) === null,
  );

  const savePreference = (preference) => {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, preference);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <aside
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-sm border border-[#e4e8dc] bg-white p-5 text-green-deep shadow-[0_12px_40px_rgba(37,52,31,0.18)] sm:inset-x-6 sm:bottom-6 sm:p-6"
      aria-label="Cookieの設定"
      aria-live="polite"
    >
      <div className="flex items-start gap-3 sm:gap-4">
        <img className="h-10 w-10 shrink-0 object-contain sm:h-12 sm:w-12" src={villaLogo} alt="" />
        <div className="min-w-0">
          <p className="mb-2 text-[10px] font-semibold uppercase tracking-[.18em] text-pear-deep">
            Cinnamon Mantra Ayurveda Villa
          </p>
          <h2 className="m-0 text-base font-medium tracking-[.04em] sm:text-lg">Cookieの設定</h2>
          <p className="mb-0 mt-2 text-xs leading-[1.9] text-[#6c7068] sm:text-sm">
            当サイトでのCookieの使用についてお選びください。「必要なCookieのみ」を選ぶと、この設定を保存するための情報だけを使用します。
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          className="min-h-11 rounded-sm border border-[#d5dfc3] px-4 py-2 text-xs font-medium tracking-[.04em] text-green-deep transition-colors hover:bg-[#f3f5eb] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pear-deep sm:min-w-40"
          type="button"
          onClick={() => savePreference('necessary')}
        >
          必要なCookieのみ
        </button>
        <button
          className="min-h-11 rounded-sm bg-green-deep px-4 py-2 text-xs font-medium tracking-[.04em] text-white transition-colors hover:bg-pear-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pear-deep sm:min-w-32"
          type="button"
          onClick={() => savePreference('all')}
        >
          すべて許可
        </button>
      </div>
    </aside>
  );
}

export default CookieConsent;